import React from 'react';

const AllergiesAndRiskCardPdf = ({ header, values, t }) => {
  // Ensure values is an array and convert it to a comma-separated string
  const formattedValues = Array.isArray(values) && values.length > 0
    ? values.join(", ") // Join items with a comma and space
    : <span className="text-gray-600 text-xs leading-normal text-center px-2 w-full"></span>;

  return (
    <div className="flex flex-col h-full py-3 rounded-2xl" style={{ border: '1px solid #E5E7EB' }}>
      {/* Header */}
      <small className="text-xs text-gray-600 tracking-tighter text-center mb-2">
        {header}
      </small>

      {/* Content */}
      <p className=" text-gray-600 text-sm leading-wider break-words px-3">
        {formattedValues}
      </p>
    </div>
  );
};

export default AllergiesAndRiskCardPdf;